(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reliable-multilang-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const popup = document.querySelector('[data-rhs-popup]');
  if (!popup) return;

  const locale = popup.dataset.locale || 'default';
  const key = 'rhs-headspa-popup-last-closed-' + locale;
  const hours = Number(popup.dataset.frequencyHours || 24);
  const params = new URLSearchParams(window.location.search);
  const preview = params.has('preview_theme_id')
    || params.get('popup_test') === '1'
    || window.Shopify?.designMode === true;
  const customerPosted = window.location.search.includes('customer_posted=true');

  const openPopup = () => {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('rhs-popup-open');
    window.setTimeout(() => {
      const field = popup.querySelector('input[type="email"]');
      if (field && window.matchMedia('(min-width: 750px)').matches) field.focus();
    }, 60);
  };

  const closePopup = () => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rhs-popup-open');
    try {
      localStorage.setItem(key, String(Date.now()));
    } catch (error) {
      void error;
    }
  };

  popup.querySelectorAll('[data-rhs-close]').forEach((el) => {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  let shouldOpen = preview || customerPosted;
  if (!shouldOpen) {
    try {
      const lastClosed = Number(localStorage.getItem(key) || 0);
      shouldOpen = !lastClosed || ((Date.now() - lastClosed) / 3600000) >= hours;
    } catch (error) {
      void error;
      shouldOpen = true;
    }
  }

  // Performance: wait for meaningful visitor engagement
  // before displaying the commercial popup.
  // Preview and form confirmation retain their original timing.
  if (shouldOpen) {
    if (preview || customerPosted) {
      window.setTimeout(openPopup, customerPosted ? 250 : 3500);
    } else {
      let popupScheduled = false;

      const showAfterEngagement = () => {
        if (popupScheduled || window.scrollY < 200) return;

        popupScheduled = true;
        window.removeEventListener('scroll', showAfterEngagement);

        window.setTimeout(() => {
          if (document.visibilityState === 'visible') {
            openPopup();
          } else {
            const showWhenVisible = () => {
              if (document.visibilityState !== 'visible') return;
              document.removeEventListener('visibilitychange', showWhenVisible);
              openPopup();
            };

            document.addEventListener('visibilitychange', showWhenVisible);
          }
        }, 1800);
      };

      window.addEventListener('scroll', showAfterEngagement, { passive: true });
      showAfterEngagement();
    }
  }
})();
  } catch(e) { console.error(e); }
})();

})();
